import { log } from '@/Utils/logger';

export const refreshPage = async (): Promise<void> => {
  if ('caches' in window) {
    const cacheNames = await caches.keys();
    await Promise.all(cacheNames.map((cacheName) => caches.delete(cacheName)));
  }

  try {
    await fetch(window.location.href, {
      cache: 'reload',
      credentials: 'same-origin',
    });
  } catch (error) {
    log.error(
      {
        func: 'refreshPage',
        error,
      },
      'Document revalidation failed before page refresh',
    );
  }

  const url = new URL(window.location.href);
  url.searchParams.set('_refresh', String(Date.now()));
  window.location.replace(url.toString());
};
